import { CLASSES, COLORS } from '../../assets/styles/styles'
import BackIcon from '../../assets/icons/success.svg'
import { Image } from 'react-bootstrap'
import { useLanguage } from '../../context/LanguageContext'

export default function Success() {
  const { language } = useLanguage()
  return (
    <div
      className={
        CLASSES.content_center + 'flex-column mb-3 flex-wrap gap-3 mt-5 pt-5'
      }
    >
      <Image src={BackIcon} />
      <h5 style={{ color: COLORS.theme }}>{language.created_successfully}</h5>
      <p
        className='text-center text-muted opacity-75'
        style={{ maxWidth: 250 }}
      >
        {language.prize_info_submitted_successfully}
      </p>
    </div>
  )
}
